import React, { Component } from "react";
import {Card, Form, Button, Row, Col, Alert, Tab, Tabs} from "react-bootstrap";
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { coberturasTratamento } from '../../common/utils';
import { withRouter } from '../../common/with-router';
import AsyncSelect from 'react-select/async';
import { FaArrowDown, FaArrowUp, FaCheck, FaTimes, FaStream, FaEye } from "react-icons/fa";

class DoencasEdit extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.onChangeCID = this.onChangeCID.bind(this);

        this.enviaRegistro = this.enviaRegistro.bind(this);

        this.fileInput = React.createRef();

        this.state = {
            nome: '',
            cid_id: '',
            cid_nome: '',
            resumo: '',
            caracteristicas: '',
            protocolo_tratamento: '',
            moleculas_tratamento: '',
            cobertura_tratamento: '',
            cidIdHelper: '',
            nomeHelper: '',
            erroLoadRegistro: "",
            doenca_id: "",
            titulo_pagina: "",
            loading: false,
        };
    }

    componentDidMount(){
        const id = this.props.router.params.id;

        if(id){
            this.setState({
                doenca_id: id,
                titulo_pagina: 'Editando Protocolo de Tratamento',
                loading: true,
                erroLoadRegistro: ''
            })

            //consulta os dados do programa na api
            api.get(`/doencas/${id}`)
            .then(response => {
                const dados = response.data;

                //preenche os inputs
                this.setState({
                    erroLoadRegistro: '',
                    nome: dados.nome,
                    cid_id: dados.cid_id,
                    resumo: dados.resumo,
                    caracteristicas: dados.caracteristicas,
                    protocolo_tratamento: dados.protocolo_tratamento,
                    moleculas_tratamento: dados.moleculas_tratamento,
                    cobertura_tratamento: dados.cobertura_tratamento,
                    cid_nome: dados.dados_cid.codigo + ' - ' + dados.dados_cid.descricao,
                    loading: false
                })
            })
            .catch(error => {
                let erro_msg = 'Erro ao consultar doença, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }

                this.setState({
                    erroLoadRegistro: erro_msg,
                })
            });
        }
        else {
            this.setState({
                doenca_id: '',
                titulo_pagina: 'Adicionar Protocolo de Tratamento',
                loading: false,
                erroLoadRegistro: '',
            })
        }
    }

    carregarCids = async (inputValue) => {
        if (inputValue.length < 3) return [];
        try {
            const response = await api.get(`/doencas/cids/?busca=${inputValue}`);
            const opcoes = response.data.results.map(cid => ({
                value: cid.id,
                label: cid.codigo + ' - ' + cid.descricao
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar CIDs:', error);
            return [];
        }
    };

    enviaRegistro = (e) => {
        e.preventDefault();

        const formData = new FormData();

        this.setState({
            loading: true,
            nomeHelper: "",
            cidIdHelper: ""
        });

        //vererifica se é edição ou adição
        const url = (this.state.doenca_id) ? '/doencas/'+this.state.doenca_id+'/' : '/doencas/'
        const metodo = (this.state.doenca_id) ? 'put' : 'post'

        formData.append('nome', this.state.nome);
        formData.append('cid_id', this.state.cid_id);
        formData.append('resumo', this.state.resumo);
        formData.append('caracteristicas', this.state.caracteristicas);
        formData.append('protocolo_tratamento', this.state.protocolo_tratamento);
        formData.append('moleculas_tratamento', this.state.moleculas_tratamento);
        formData.append('cobertura_tratamento', this.state.cobertura_tratamento);

        //envia para api
        api({
            method: metodo,
            url: url,
            data: formData,
        })
        .then(response => {
            const MySwal = withReactContent(Swal)
            const textSwal = (this.state.doenca_id) ? 'Doença atualizada com sucesso' : 'Doença cadastrada com sucesso';

            MySwal.fire({
                title: 'Sucesso!',
                html: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
            this.setState({
                loading: false,
            })
            
            //redireciona
            if(!this.state.doenca_id){
                this.props.router.navigate("/doencas");
            }
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar o doença, verifique os campos e tente novamente';            

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key === 'nome'){
                        this.setState({ nomeHelper: value })
                    }
                    if(key === 'cid_id'){
                        this.setState({ cidIdHelper: value })
                    }
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
            })    
            
            this.setState({
                loading: false,
            })
        });
    };

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    };

    onChangeCID = (cidSelecionado) => {
        this.setState({ cid_id: cidSelecionado ? cidSelecionado.value : '', cid_nome: cidSelecionado ? cidSelecionado.label : '' });
    };

    render(){
        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">{this.state.titulo_pagina}</h4>
                    </Col>
                </Row>
                <Tabs defaultActiveKey="dadosDoenca" id="tabs-doenca" className="aditus-tabs">
                    <Tab eventKey="dadosDoenca" title="Dados do Protocolo">
                        <Card className="cardDestaque">
                            <Card.Body>                    
                                <Form onSubmit={this.enviaRegistro}>
                                    <h4>Dados do Protocolo</h4>
                                    <Row>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Nome da Doença</Form.Label>
                                                <Form.Control type="text" name="nome" required placeholder="Nome da Doença" value={this.state.nome} onChange={this.handleChange} />    
                                                <Form.Text id="formNomeHelpBlock" className="text-danger">{this.state.nomeHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>CID</Form.Label>
                                                <AsyncSelect
                                                    cacheOptions
                                                    loadOptions={this.carregarCids}
                                                    defaultOptions
                                                    name="cid"
                                                    placeholder="Buscar CID..."
                                                    noOptionsMessage={() => "Nenhum CID encontrado"}
                                                    onChange={this.onChangeCID}
                                                    value={this.state.cid_id ? { value: this.state.cid_id, label: this.state.cid_nome } : null}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Cobertura do Tratamento</Form.Label>
                                                <Form.Control as="select" name="cobertura_tratamento" value={this.state.cobertura_tratamento} required onChange={this.handleChange}>
                                                    <option value="">Selecione a cobertura do tratamento</option>
                                                    {Object.entries(coberturasTratamento).map(([sigla, nome]) => (
                                                        <option key={sigla} value={sigla}>{nome}</option>
                                                    ))}
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={12} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Resumo</Form.Label>
                                                <Form.Control 
                                                    as="textarea" 
                                                    required 
                                                    placeholder="Resumo" 
                                                    name="resumo"
                                                    value={this.state.resumo} 
                                                    onChange={this.handleChange} 
                                                    className="custom-textarea"
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={12} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Características</Form.Label>
                                                <Form.Control 
                                                    as="textarea" 
                                                    required 
                                                    placeholder="Características" 
                                                    name="caracteristicas"
                                                    value={this.state.caracteristicas} 
                                                    onChange={this.handleChange} 
                                                    className="custom-textarea"
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={12} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Protocolo de Tratamento</Form.Label>
                                                <Form.Control 
                                                    as="textarea" 
                                                    required 
                                                    placeholder="Protocolo de Tratamento" 
                                                    name="protocolo_tratamento"
                                                    value={this.state.protocolo_tratamento} 
                                                    onChange={this.handleChange} 
                                                    className="custom-textarea"
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={12} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Moléculas Tratamento</Form.Label>
                                                <Form.Control 
                                                    as="textarea" 
                                                    required 
                                                    placeholder="Moléculas Tratamento" 
                                                    name="moleculas_tratamento"
                                                    value={this.state.moleculas_tratamento} 
                                                    onChange={this.handleChange} 
                                                    className="custom-textarea"
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    {this.state.erroLoadRegistro ? 
                                    <Alert variant="warning">
                                        {this.state.erroLoadRegistro}
                                    </Alert> : ''
                                    }                                      
                                    <Button variant="success" type="submit" className="btn-submit mt-3" disabled={this.state.loading}>
                                        {this.state.loading ? (
                                            <span className="spinner-border spinner-border-sm"></span>
                                        ) : (
                                            <>
                                                <FaCheck className="me-1" /> Salvar
                                            </>
                                        )}
                                    </Button>
                                </Form> 
                            </Card.Body>                
                        </Card>
                    </Tab>
                </Tabs>
            </div>
        )
    }
}

export default withRouter(DoencasEdit);